// tslint:disable-next-line function-name export-name
export function $(
    query: string,
    container: HTMLElement | Document = document,
): HTMLElement | undefined {
    const element: Element | null = container.querySelector(query);

    if (element === null) {
        return;
    }

    return <HTMLElement>element;
}
